export default {
  BUSCARPLACAALERTA (state, info) {
    state.buscarplacaalerta = info  
  },
  CADASTRARALERTA (state, info) {
    state.cadastraralerta = info
  },
  ALTERARALERTA (state, info) {
    state.alteraralerta = info
  },
  DELETARALERTA (state, info) {
    state.deletaralerta = info
  },
  BUSCARALERTAS (state, info){
    state.buscaralertas = info
  }
}